import { CrossHairPluginProps } from "@ui-lib/core/chartJS/plugins/crosshair"
import { _DeepPartialObject } from "@utilityTypes/reactChartJsUtilTypes"
import { ChartOptions } from "chart.js"

export const chartOptionsMultiAxis = (
	type: "bar" | "line",
	yAxisTitle: string,
	y1AxisTitle?: string,
	y2AxisTitle?: string,
	units?: { label: string; unit: string }[],
	isTimeSeries?: boolean,
	addCrossHair?: boolean | _DeepPartialObject<CrossHairPluginProps>,
	precision?: number
) => {
	const options: ChartOptions<typeof type> = {
		responsive: true,
		animation: false,
		maintainAspectRatio: false,
		interaction: {
			mode: "index",
			intersect: false,
		},
		plugins: {
			tooltip: {
				callbacks: {
					label(tooltipItem) {
						return `${tooltipItem.dataset.label}: ${
							typeof tooltipItem.parsed.y === "number"
								? tooltipItem.parsed.y.toFixed(precision ?? 1)
								: tooltipItem.parsed.y
						} ${units?.find((u) => u.label === tooltipItem.dataset.label)?.unit ?? ""}`
					},
				},
				intersect: false,
				mode: "index",
			},
			...(addCrossHair === true
				? {
						crosshairV2: {
							crosshair: { enabled: true },
							sync: { enabled: false },
						},
					}
				: addCrossHair !== undefined && addCrossHair !== false
					? { crosshairV2: addCrossHair }
					: {}),
			legend: {
				position: "bottom",
			},
			title: {
				display: false,
				text: ``,
			},
		},
		scales: {
			y: {
				title: {
					display: true,
					text: yAxisTitle,
					font: {
						size: 14,
					},
				},
			},
			y1: {
				display: y1AxisTitle !== undefined ? true : false,
				// position: "right",
				title: {
					display: true,
					text: y1AxisTitle,
					font: {
						size: 14,
					},
				},
				grid: { display: false },
			},
			y2: {
				display: y2AxisTitle !== undefined ? true : false,
				// position: "right",
				title: {
					display: true,
					text: y2AxisTitle,
					font: {
						size: 14,
					},
				},
				grid: { display: false },
			},
			x: {
				type: isTimeSeries === true ? "time" : "category",
				ticks: {
					major: { enabled: true },
					font: function (ctx, options) {
						if (ctx.tick !== undefined && ctx.tick.major === true) {
							return { weight: "bold", size: 15 }
						}
					},
				},
				time: {
					displayFormats: {
						day: "dd MMM",
						hour: "ha",
						minute: "HH:mm",
						quarter: "qqq yyyy", // e.g., Q1 2023
					},
					tooltipFormat: "dd MMM - HH:mm:ss",
				},
				title: {
					display: false,
					text: "",
				},
			},
		},
	}
	return options
}
